import { defineMessages } from 'react-intl';

export const scope = 'app.components.SettingsPage';

export const messages = defineMessages({
  assessmentSettings: { id: `${scope}.assessmentSettings`, defaultMessage: 'Assessment Settings' },
  associationSettings: { id: `${scope}.associationSettings`, defaultMessage: 'Association Settings' },
  formatStageTemplates: { id: `${scope}.formatStageTemplates`, defaultMessage: 'Format Stage Templates' },
  ageGroups: { id: `${scope}.ageGroups`, defaultMessage: 'Age Groups' },
  loading: { id: `${scope}.loading`, defaultMessage: 'Loading…' },
});
